import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import Swal from 'sweetalert2';
import Configs from '@shared/constants/configs';
import { FormControl } from '@angular/forms';
import DateUtils from '@shared/utils/date-utils';
import Utils from '@shared/utils/utils';

@Component({
  selector: 'app-delete-data',
  templateUrl: './delete-data.component.html',
  styleUrls: ['./delete-data.component.scss']
})
export class DeleteDataComponent extends DialogBase implements OnInit {
  title: any;
  productType: any;
  selectedProductType: string;
  bsConfig = {
    containerClass: 'theme-dk', showWeekNumbers: false, dateInputFormat: Configs.format.dateMMYYYY
  };
  startDate = new FormControl(null);
  startMaxDate: Date;
  today: Date;

  ngOnInit(): void {
    this.setDateRestriction()
  }

  setProductType(event?) {
    this.selectedProductType = event;
  }

  deleteData() {
    const year = this.startDate.value.getUTCFullYear();
    let month = this.startDate.value.getUTCMonth() + 1;
    if (month === 13) {
      month = 1;
    }
    Swal.fire({
      icon: 'question',
      title: 'Delete Sales Data',
      text: 'Would you like to delete data? Are you sure?',
      showConfirmButton: true,
      confirmButtonText: 'Ok',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiService.salesData.deleteSalesData(this.selectedProductType, year, month)
          .subscribe(res => {
            Swal.fire({
              icon: 'success',
              title: 'Sales Data has been deleted',
            }).then((result) => {
              this.onClose.next(null);
              this.bsModalRef.hide();
            })
          }, err => Utils.showError(err));
      }
    });
  }

  deleteAllData() {
    Swal.fire({
      icon: 'question',
      title: 'Delete All Sales Data',
      text: 'Would you like to delete all data? Are you sure?',
      showConfirmButton: true,
      confirmButtonText: 'Ok',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiService.salesData.deleteAllSalesData()
          .subscribe(res => {
            Swal.fire({
              icon: 'success',
              title: 'All Sales Data has been deleted',
            }).then((result) => {
              this.onClose.next(null);
              this.bsModalRef.hide();
            })
          }, err => Utils.showError(err));
      }
    })
  }

  setDateRestriction() {
    this.today = DateUtils.getHqMidnight(new Date());
    this.startMaxDate = this.today;
  }
}
